import React from 'react';
import { Space, Typography } from 'antd';
import "./css/IconifiedText.css"; // Ensure you create and import this CSS file


const { Text } = Typography;

const IconifiedText = ({ 
  text, 
  iconFileIndex, 
  iconIndex, 
  iconDisplaySize, 
  iconPosition = "left",
  textType = "medium",
  textStyle = "secondary",
  textTreatment = '',
}) => {
  const noIcon = (iconIndex === null);

  if(iconPosition === "right") {
    return (
      <Space className="iconified-text">
        <Text className={`custom-text text-${textType} text-${textStyle} ${textTreatment ? textTreatment : ''}`}>
          {text}
        </Text>
      </Space>
    );
  } else{
    return (
      <Space className="iconified-text">
       
        <Text className={`custom-text text-${textType} text-${textStyle}`}>
          {text}
        </Text>
      </Space>
    );
  }
};

export default IconifiedText;
